<template>
    <div v-if="steps_item.children">
        <div class="d-flex align-items-center steps_main-step" v-b-toggle="steps_item.id">
            <base-icon name="chevron_more" class="chevron" />
            <div class="steps_main-step_content">
                {{ steps_item.title }}
                <span v-if="steps_item.subtitle && active_step.startsWith(steps_item.id)" class="d-block" style="font-size: .75rem;">{{ steps_item.subtitle }}</span>
            </div>
        </div>
        <b-collapse :id="steps_item.id" :visible="active_step.startsWith(steps_item.id)" accordion="steps-accordion">
            
            <child_steps
                :steps_item_children="steps_item.children" :level="0"
                :active_step="active_step"
                v-on:set_active_step="(step) => $emit('set_active_step', step)"
            />

        </b-collapse>
    </div>
</template>

<script>
import child_steps from './child_steps'
export default {
    props :
    {
        steps_item : Object,
        active_step : String,
    },

    components :
    {
        child_steps,
    },
}
</script>

<style scoped>
.chevron
{
    transition: transform .25s !important;
}
.collapsed .chevron
{
    transform: rotate(-90deg) !important;
}
.steps_main-step
{
    gap: .75rem;
    padding-block: .5rem;
    padding-left: .75rem;
}
.steps_main-step_content
{
    flex: 1;
}
</style>